import { render, staticRenderFns } from "./active-filter-indicator.vue?vue&type=template&id=8a069eea&scoped=true"
import script from "./active-filter-indicator.vue?vue&type=script&lang=js"
export * from "./active-filter-indicator.vue?vue&type=script&lang=js"
import style0 from "./active-filter-indicator.vue?vue&type=style&index=0&id=8a069eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a069eea",
  null
  
)

/* custom blocks */
import block0 from "./active-filter-indicator.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports